import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import ModalComponent from "../modal/modal.component";
import ImageComponent from "../image/image.component";
import { useEffect } from "react";
import "./blade-runner-styles.scss";
import bladeRunnerLogo from "../../../../src/assets/blade-runner/logo-blade-runner.webp";

// NOTE: No Session 09 images provided in the notes.
// If you later add Session 09 images, drop the imports in here and add <ImageComponent /> blocks back in.
import cover from "../../../../src/assets/blade-runner/session09/blade-runner-session-09-cover.webp";
import logoBrightEyes from "../../../../src/assets/blade-runner/session09/neon_bright_eyes.webp";
import kitty from "../../../../src/assets/blade-runner/session09/skinner-goodbye-kitty.webp";
import memoryVaults from "../../../../src/assets/blade-runner/session09/memory-vaults.webp";
import grimsky from "../../../../src/assets/blade-runner/session09/gang-rueboys.webp";
import downtimeMarion from "../../../../src/assets/blade-runner/session09/marion-and-wanda.webp";
import lloyd from "../../../../src/assets/blade-runner/session09/lloyd-of-the-overlook-token.webp";
import interrogation from "../../../../src/assets/blade-runner/session09/interrogation.webp";
import bloodSample from "../../../../src/assets/blade-runner/session09/the-blood-sample.webp";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, 0.7) ",
  color: "white",
  marginBottom: "15px",
};

const BRSession09 = () => {
  const [showModal, setShowModal] = React.useState("");
  const [modalData, setModalData] = React.useState({});

  const handleClick = (img, body, isLegend, caption) => {
    setModalData({
      body: body,
      image: img,
      isLegend: isLegend,
      caption: caption,
    });
    handleOpenModal();
  };
  const handleOpenModal = () => setShowModal("show");
  const handleCloseModal = () => setShowModal("", "");

  const section1Data = [
    {
      title: "Bright Eyes Beauty Salon (Day 1, Shift 3 — Evening)",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ImageComponent
            image={cover}
            caption="Neon Mirror"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Blade Runner Session 09: Neon Mirror. Skinner sets eyes on his doppelganger at Bright Eyes and turns a quiet surveillance into a rooftop chase—ending with an imposter in cuffs and a murder that makes it all feel personal."
          ></ImageComponent>

          <p>
            Bright Eyes glowed like a cheap promise under the rain. Skinner
            didn’t go in alone—he called his street contact Grimsky and asked
            for a few ruepunks to watch the front.
          </p>

          <p>
            Through the window, Skinner saw his lookalike talking to Seraphine,
            the salon proprietor. Then the other “Skinner” slipped into the
            bathroom.
          </p>

          <p>
            A spiky-haired youth in a leather jacket flashed a ruesign outside.
            Grimsky’s boys had eyes on the door. Skinner moved to the alley
            entrance, guided by a KIA blueprint of the building layout.
          </p>

          <p>
            His mood ring shifted as he closed on the back—an old habit becoming
            a crutch. He pushed himself to stay quiet, and the ring helped him
            claw back a little resolve after the effort.
          </p>

          <p>
            The bathroom door was locked. Skinner played it slick—like he was
            the customer Seraphine had just been talking to.
          </p>

          <p>
            Skinner:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              Can you open the door for me? Left my wallet in there and locked
              myself out.
            </font>
          </p>

          <p>
            Seraphine approached, wrinkling her nose like something didn’t line
            up—then shrugged it off in the name of chinyen.
          </p>

          <p>
            Seraphine:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              I can see you changed your tee-shirt too.
            </font>
          </p>

          <p>
            Skinner glanced down at his <i>Goodbye Kitty</i> tee and grinned
            like it didn’t matter.
          </p>

          <p>
            The bathroom was empty. A ceiling tile had been shifted—just enough
            to tell him the truth.
          </p>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ImageComponent
            image={kitty}
            caption="Bright Eyes"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Seraphine: <br/><i>Looks like you changed your tee-shirt too.</i>"
          ></ImageComponent>
          <p>
            Grimsky’s rueboy texted a second later:
            <font style={{ fontStyle: "italic", color: "cornflowerblue" }}>
              {" "}
              Dude looks like you up on the roof running.
            </font>
          </p>

          <p>
            Skinner shot back:
            <font style={{ fontStyle: "italic", color: "cornflowerblue" }}>
              {" "}
              Keep an eye on him. I’m going after him.
            </font>
          </p>

          <p>
            The chase spilled upward—rain-slick ducts, neon holo-ads pulsing
            like heartbeat monitors, rat-birds flaring into the air as the
            imposter tried to disappear among the rooftop clutter.
          </p>

          <p>
            The fake Skinner pushed hard to hide. Skinner pushed harder to cut
            him off. His old back injury screamed in protest.{" "}
            <i>(Damage: Skinner.)</i>
          </p>

          <p>
            The imposter broke himself trying to stay out of sight—collapsing
            near a glowing sign, curled in a puddle, chanting:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              no, no, no…
            </font>
          </p>

          <p>
            Skinner limped in, knelt with a wince, and zip-tied the imposter’s
            hands.
          </p>

          <p>The city didn’t applaud. It just kept raining.</p>

          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },

    {
      title: "Transport & Lockup (Day 1, Shift 3 — Late Evening)",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ImageComponent
            image={grimsky}
            caption="Grimsky"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Grimsky: a respected rueboy. The Rueboys are a loose, street-level gang of spiked-hair punks and leather-clad runners who deal in cheap stims and designer narcotics, but their real power lies in being a decentralized human surveillance network woven through the alleys, markets, and rooftops of the city. They specialize in tailing targets, passing observations hand-to-hand without ever looking organized, and monetizing what they see—faces, habits, routes—making them invaluable as informants, couriers, and watchers for anyone who knows how to use them, including Blade Runners like Skinner.
"
          ></ImageComponent>
          <p>
            Skinner called Marion. Minutes later, Marion’s spinner swung by to
            pick him up and help escort the silent body double to LAPD HQ.
          </p>

          <p>
            During the flight, Marion got a message from Quell:
            <font style={{ fontStyle: "italic", color: "cornflowerblue" }}>
              {" "}
              I know you and Skinner are on the case. Stop by when you can; earn
              that medal.
            </font>
          </p>

          <p>
            The imposter didn’t speak. Not once. They decided to save the
            interrogation for morning—when the isolation room and the clock
            could do some of the work for them.
          </p>

          <p>
            Skinner called Grimsky to close the loop. Grimsky laughed:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              Hard to believe someone else as ugly as you out there.
            </font>
          </p>

          <p>
            Skinner cashed in the earlier favor and told Grimsky to have the
            rueboys tail Seraphine through the night anyway—just in case the
            salon was more than it looked.
          </p>

          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },

    {
      title: "Downtime: Wanda & The Overlook (Day 1, Shift 4 — Night)",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ImageComponent
            image={downtimeMarion}
            caption="Downtime with Wanda"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Marion spent downtime at home with Wanda, his DiJi girlfriend—trying to talk like a normal person after an abnormal day."
          ></ImageComponent>
          <p>
            Marion spent downtime at home with Wanda, his DiJi girlfriend—trying
            to talk like a normal person after an abnormal day. He told her
            about the big football game, about Skinner’s double, about how the
            world kept daring him to prove he was real.
          </p>

          <p>
            The more he talked, the more the edges blurred. A sinking spiral of
            identity he couldn’t quite name.
          </p>

          <p>
            Skinner went to the Overlook. The bar smelled like old varnish and
            newer lies. Lloyd—replicant barkeep, foster brother, Cityspeaker—was
            behind the counter like he’d always been there, like the city itself
            had a face tonight.
          </p>

          <p>
            Skinner’s memory surfaced as it often did when he was tired: a dim
            nightclub, his parents using cocaine, the moment he realized people
            closest to you can be strangers. Not long after, they were arrested.
            Mordecai went into foster care. Lloyd went with him.
          </p>

          <p>Skinner finally said the quiet part out loud:</p>

          <p>
            Skinner:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              Lloyd, there’s shit going on we don’t know about. I don’t even
              know what’s real right now. What do you know about the replicant
              underground?
            </font>
          </p>

          <p>Lloyd nodded like a door had opened.</p>

          <p>
            Lloyd:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              Welcome to being a replicant, Skinner. We have to live every day
              wondering what’s real and what’s fake.
            </font>
          </p>

          <p>Lloyd gave him leads:</p>
          <ul>
            <li>
              The feather angle points to <b>Runciter’s Zoological</b> on
              Animoid Row.
            </li>
            <li>
              If Skinner’s lookalike is trying to leave town, he’ll surface at
              the <b>Sepulveda Sea Wall</b>—the new Underground meetup since the
              Moon Bus got decommissioned back in Case File 1.
            </li>
            <li>
              If anyone knows about a facility making black market replicants,
              it might be <b>Doc Badger</b>—a long shot, but a smart one.
            </li>
          </ul>

          <p>
            Skinner left the Overlook with answers that felt like more
            questions.
          </p>

          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },

    {
      title: "Bright Eyes Crime Scene (Day 2, Shift 1 — Early Morning)",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ImageComponent
            image={logoBrightEyes}
            caption="Bright Eyes"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Bright Eyes Beauty Salon is a tiny, unremarkable Sector 1 beauty parlor offering the usual stereoscopic tattoos and cosmetic augmentations, but it’s quietly important because its manager Seraphine is a Replicant Underground sympathizer who’s helped fugitive Nexus-8s alter their appearance."
          ></ImageComponent>
          <p>
            At 4:00 a.m., Grimsky’s text hit Skinner like a punch:
            <font style={{ fontStyle: "italic", color: "cornflowerblue" }}>
              {" "}
              Yo Skinner, my rueboy peeped your rube getting’ killed in her shop
              just a minute ago. She showed up early and some man killed her. He
              skeedaddled before my boy could peep his visage.
            </font>
          </p>

          <p>
            Holden called minutes later, officially confirming Seraphine at
            Bright Eyes Beauty Salon was dead. Skinner thought:
            <i> Tell me something I don’t know.</i>
          </p>

          <p>
            Marion arrived to find the tape already up. He flashed his
            Rep-Detect badge at a beat cop and took command by default.
          </p>

          <p>
            Seraphine was dead in her favorite cosmetic service chair. Signs of
            struggle suggested she’d been shoved into it.
          </p>

          <p>
            The method was familiar—eyes crushed like Wade Ellis’ body—but not
            as deep. Marion’s read was simple: the killer rushed, spooked by the
            watchers outside.
          </p>

          <p>
            Marion tried to capture one of the butterflies in the shop and found
            a gift card from <b>The Aurelian</b>—a sweet note gifting a
            butterfly he’d made for her. They weren’t strangers. They were
            connected.
          </p>

          <p>
            He collected blood from under Seraphine’s fingernails and murmured:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              You fought back. Sometimes that’s all we can do.
            </font>
          </p>

          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },

    {
      title: "Interrogation: A Mirror in an Orange Jumpsuit (Day 2, Shift 1–2)",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ImageComponent
            image={interrogation}
            caption="Interrogation"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Skinner sat across from his doppelganger in the interrogation room, trying to find a crack in the imposter’s silence. The replicant had Skinner’s face but none of his weight, and it was like looking into a neon mirror reflecting all his worst days sharpened into a weapon."
          ></ImageComponent>
          <p>
            In LAPD lockup, Skinner sat across from himself—orange jumpsuit,
            shackles, a metal table between them.
          </p>

          <p>
            The replicant imposter had Skinner’s face but none of his weight.
            Petulant. Volatile. Like a psychic tulpa made from Skinner’s worst
            days and sharpened into a weapon.
          </p>

          <p>
            Skinner pressed. He tried soft questions. Hard questions. Simple
            ones.
          </p>

          <p>
            Skinner:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              What is your name?
            </font>
          </p>

          <p>Nothing.</p>

          <p>
            He pushed the interrogation again and again—close enough to taste
            the truth—then came away with empty hands and that creeping feeling
            under the skin: that the city could counterfeit you and still sleep
            at night.
          </p>

          <p>
            A countdown event that might have targeted one of the detectives
            never fired—both of them spending the shift inside HQ, behind
            concrete and procedure.
          </p>

          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },

    {
      title: "Crime Lab: The Blood Match (Day 2, Shift 2 — Afternoon)",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ImageComponent
            image={bloodSample}
            caption="Blood Sample"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Coco, the Crime Lab technician, ran the blood sample from under Seraphine’s nails—and ran it again, brow furrowed.That blood? It’s Ray McCoy’s blood."
          ></ImageComponent>
          <p>
            Marion met Coco in the Crime Lab. Coco confirmed the feather trail:
            Runciter’s Zoological on Animoid Row. He also confirmed the
            butterfly was The Aurelian’s work.
          </p>

          <p>
            Marion asked Coco to expedite the blood sample from under
            Seraphine’s nails. Coco ran it—then ran it again, brow furrowed.
          </p>

          <p>
            Marion:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              Something wrong?
            </font>
          </p>

          <p>
            Coco hesitated, then asked a strange question:
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              {" "}
              Is, uh… Ray McCoy helping you and Skinner on this case?
            </font>
          </p>

          <p>
            Marion admitted McCoy was working angles down at the Sepulveda Sea
            Wall. Coco handed over the analysis sheet—and when it was clear the
            jargon wasn’t landing, Coco blurted the headline:
          </p>

          <p>
            Coco:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              That blood? It’s Ray McCoy’s blood.
            </font>
          </p>

          <p>
            A new suspicion stepped into the room and didn’t bother closing the
            door behind it.
          </p>

          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },

    {
      title: "White Dragon & The Missing Drink (Day 2, Shift 2–3 — Evening)",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ImageComponent
            image={lloyd}
            caption="Lloyd at the Overlook"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Lloyd at the Overlook, replicant barkeep, foster brother, Cityspeaker—was behind the counter like he’d always been there, like the city itself had a face tonight."
          ></ImageComponent>
          <p>
            At the end of the shift, Marion and Skinner met at White Dragon
            noodle shop near the tower. Marion told Skinner about the blood
            match.
          </p>

          <p>
            Skinner muttered <i>“Speak of the devil”</i> and turned his KIA so
            Marion could see a new text:
            <font style={{ fontStyle: "italic", color: "cornflowerblue" }}>
              {" "}
              Hey, let’s meet for that drink at the Overlook. Be there in 15.
              —McCoy
            </font>
          </p>

          <p>They went.</p>

          <p>No McCoy.</p>

          <p>
            Lloyd confirmed McCoy hadn’t been there all day. Skinner texted:
            <font style={{ fontStyle: "italic", color: "cornflowerblue" }}>
              {" "}
              Where are you and when you gonna surface?
            </font>
          </p>

          <p>
            McCoy replied:
            <font style={{ fontStyle: "italic", color: "cornflowerblue" }}>
              {" "}
              Yeah, got real busy. Something came up at the Sea Wall, I’ll be in
              touch.
            </font>
          </p>

          <p>The drink stayed undrunk. The suspicion stayed alive.</p>

          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },

    {
      title:
        "Two Visits: The Aurelian & Wallace Memory Vaults (Day 2, Shift 3 — Night)",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ImageComponent
            image={memoryVaults}
            caption="Memory Vaults"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Wallace Memory Vaults are a cavernous, museum-like archive buried inside Wallace Corp’s eerily empty HQ"
          ></ImageComponent>
          <p>
            They split for the shift. Skinner visited The Aurelian. Marion went
            to Wallace HQ to see Quell.
          </p>

          <p>
            The news of Seraphine’s death hit the old man hard. He poured
            whiskey and talked through grief like it was the only language left.
          </p>

          <p>
            The Aurelian admitted Seraphine helped replicants in trouble—not
            criminals, just the desperate—pointing them to a boat out at the
            Sepulveda Sea Wall. Worthy souls got sent to him for instructions:
            go to the long dock, raise a flag on the last pier post, wait.
          </p>

          <p>
            The Aurelian:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              Who want to kill a sweet girl like that, Skinner? Don’t sound like
              them black ops guys you told me about. This feels personal
              somehow.
            </font>
          </p>

          <p>
            Skinner promised he’d find the killer—and told the Aurelian to call
            if he heard anything at all.
          </p>

          <p>
            At Wallace HQ, Marion passed security and landed in a vast, mostly
            empty garage. Quell’s androgynous assistant led him into the Memory
            Vaults: a dim chilled cathedral of cabinets, machinery humming like
            monotone angels unsure what they were singing about.
          </p>

          <p>Quell didn’t waste time.</p>

          <p>
            Quell:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              What took so long?
            </font>
          </p>

          <p>
            Marion reminded her—gently but clearly—that he’d saved her life in a
            bombing. That debt still had weight.
          </p>

          <p>
            Marion briefed her on Ellis Vale, Skinner’s double, and the Lok Tang
            ID of Lilith Tyrell. He kept one worry back: the growing suspicion
            that McCoy might not be who he says he is.
          </p>

          <p>
            Quell led Marion into a private booth and inserted a golden
            ball-shaped storage device.
          </p>

          <p>
            The audio that played was old—pre-Blackout. A Voight-Kampff test.
            Rick Deckard interviewing a Tyrell replicant named Rachael. The
            past, preserved like a weapon.
          </p>

          <p>
            Marion and Quell discussed why a black market replicant would pose
            as maintenance just to steal this recording—and why Tyrell legacy
            keeps crawling back out of the grave.
          </p>

          <p>
            Quell provided Marion a tailored “psyche weakness” interrogation
            cheat sheet—custom Wallace technique—built for black market
            replicant profiles and the Tyrell/Wade Ellis admixture data.
          </p>

          <p>
            It would give the Rep-Detects an edge the next time they tried to
            crack Skinner’s silent mirror.
          </p>

          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
  ];

  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../src/assets/blade-runner/background-blade-runner-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "Orbitron",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <a name="pageTop" href="#pageTop">
                  <img
                    src={bladeRunnerLogo}
                    style={{
                      maxWidth: "400px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                    }}
                    alt="Blade Runner campaign"
                  />
                </a>
              </main>

              <h1 className="cover-heading">Neon Mirror</h1>
              <small>Blade Runner Session 09</small>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card style={cardStyle}>
            <Card.Body>
              <Card.Title
                id="cardTitle-blade-runner"
                className="cardTitle-blade-runner"
              >
                <span
                  style={{
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  Grimsky’s rueboys help Skinner with rooftop chase above Bright
                  Eyes. A fresh murder drags the investigation toward the
                  Sepulveda Sea Wall and the quiet machinery of the Underground.
                  A surprising blood match hits close to home, and Wallace
                  confirms Ellis wasn’t chasing money—he was chasing a
                  Tyrell-era audio recording.
                </span>
                <br />
                <font
                  style={{
                    color: "#C21E56",
                    textAlign: "center",
                    fontStyle: "italic",
                  }}
                >
                  WARNING: SPOILERS for Fiery Angels case file.{" "}
                </font>
                <br />
                <small>
                  ⇐ Session 08:{" "}
                  <a href="./blade-runner-session-08">Bright Eyes</a> ☠ Session
                  09: <a href="./blade-runner-session-10">McCoy</a> ⇒{" "}
                </small>
              </Card.Title>

              <div>
                <ContentContainer data={section1Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default BRSession09;
